// src/config.js
export const VERSION = "1.6.11";